export default function () {
  const handleError = error => {
    const err = {};
    if (error.response) {
      err.status = error.response.status;
      // The service responded with a status code outside 2xx
      err.errors = error.response.data.errors;
      err.message = `logref ${error.response.data.logref}`;
      err.logref = error.response.data.logref;
    } else if (error.request) {
      // The request has been made but no response has been received
      const requestedUrl = error.request.url;
      err.message = `cannot get any response from ${requestedUrl}`;
    } else {
      // Hasn't been possible to make the request
      err.message = `Error ${error.message}`;
    }

    return err;
  };

  return {
    handleError
  };
}
